import React from 'react';
import {t} from 'react-switch-lang';
import {NavLink} from 'react-router-dom';
import {useUserContext} from '../../../contexts/UserContext';
import roles from '../../../utils/roles';
const Risks = () => {
  const user = useUserContext();
  const userRoles = user?.authorities;
  const deletedRiskRoles = [roles.role_super_admin, roles.role_risk_sector];

  const navigation = [
    {
      name: t('sidebar.risks.allUnclosed'),
      link: '/risks',
      tooltip: t('sidebar.risks.allUnclosed'),
    },
    {
      name: t('sidebar.risks.entered'),
      link: '/entered-risks',
      tooltip: t('sidebar.risks.entered'),
    },
    {
      name: t('sidebar.risks.verified'),
      link: '/verified-risks',
      tooltip: t('sidebar.risks.verified'),
    },
    {
      name: t('sidebar.risks.during'),
      link: '/during-risks',
      tooltip: t('sidebar.risks.during'),
    },
    {
      name: t('sidebar.risks.rejected'),
      link: '/rejected-risks',
      tooltip: t('sidebar.risks.rejected'),
    },
    {
      name: t('sidebar.risks.closed'),
      link: '/closed-risks',
      tooltip: t('sidebar.risks.closed'),
    },
    ...(deletedRiskRoles.some((r) => userRoles?.includes(r))
      ? [
          {
            name: t('sidebar.risks.deleted'),
            link: '/deleted-risks',
            tooltip: t('sidebar.risks.deleted'),
          },
        ]
      : []),
  ];

  return (
    <div className="risks">
      <div className="sidebar-title">
        <div> {t('sidebar.risks.title')}</div>
      </div>
      {navigation.map((item, idx) => (
        <NavLink
          activeClassName="active"
          className="administration-links links reports-tooltip-container"
          to={item.link}
          key={idx}
        >
          <div className="report-text">{item.name}</div>
          {item.name.length > 28 ? (
            <div className="second-tooltip-text">
              <span>{item.name}</span>
            </div>
          ) : (
            ''
          )}
        </NavLink>
      ))}
    </div>
  );
};

export default Risks;
